module.exports = __webpack_public_path__ + "static/media/mawiba-logo.fe7cbae5.png";